import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { processData } from '../data/mock';
import { videos } from '../data/videos';
import YouTubeEmbed from './YouTubeEmbed';

const Process = () => {
  return (
    <section className="process-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Your Journey to Relief</h2>
          <p className="section-subtitle">
            A comprehensive, personalized process designed around your needs
          </p>
        </div>

        <div className="process-timeline">
          {processData.map((item) => (
            <div key={item.step} className="process-item">
              <div className="process-number-wrapper">
                <div className="process-number">{item.step}</div>
                {item.step < processData.length && (
                  <div className="process-connector"></div>
                )}
              </div>
              
              <div className="process-content">
                <h3 className="process-title">{item.title}</h3>
                <p className="process-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="process-expect-row">
          <Link to="/what-to-expect" className="process-expect-link" data-testid="process-what-to-expect-link">
            Read what to expect: outcomes, timelines and fees <ArrowRight size={16} />
          </Link>
        </div>

        <div className="process-video-row">
          <YouTubeEmbed
            youtubeId={videos.assessmentProcess.youtubeId}
            title={videos.assessmentProcess.title}
            description={videos.assessmentProcess.description}
            variant="card"
          />
        </div>
      </div>
    </section>
  );
};

export default Process;
